import { Divider, Stack } from '@ace-clublabs/shared-component-library';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';

export const ReviewDiscountAndTaxSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);

  const salesTax = sessionData?.priceCart?.salesTax || 0;
  const autopayDiscount = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.AUTOPAY_DISCOUNT);
  const autoPayDiscountAmount = autopayDiscount && autopayDiscount.price;

  return (
    <Stack>
      <Stack direction="column" className="discount-and-tax-section" width="100%" gap="0.5rem">
        {autopayDiscount && (
          <>
            <ReviewItem
              title="One-time Auto Pay savings"
              id="autopay"
              code={CartProductCode.AUTOPAY_DISCOUNT}
              price={0}
              discount={autoPayDiscountAmount}
              discountedPrice={-autoPayDiscountAmount!}
              description="One-time Auto Pay discount"
            />
          </>
        )}
        {salesTax > 0 && (
          <ReviewItem
            title="Sales tax"
            id="sales-tax"
            code={CartProductCode.SALESTAX}
            price={salesTax}
            description="Sales tax"
            className="sales-tax"
          />
        )}
      </Stack>
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
